<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择班组"
      top="8vh"
      width="800px"
  >
    <view-table
        ref="viewTable"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="mES_Teams"
        :tool-bar-show="false"
        :table-action="false"
        :table-select="false"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="班组名称">
            <el-input v-model.trim="filter.teamName" placeholder="请输入班组名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "TeamSelect",
    components: { ViewTable },
    data() {
      return {
        dialogVisible: false,
        filter: {
          teamName: "",
        },
        columnsProperty: [
          { key: "teamCode", align: "center", width: 120 },
          {
            key: "teamName",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: { color: "#2d8cf0", cursor: "pointer", fontWeight: "bold" },
                  on: {
                    click: () => this.selectRow(params.row),
                  },
                },
                params.row.teamName
              );
            },
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.viewTable && this.$refs.viewTable.loadData(1);
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      selectRow(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
    },
  };
</script>
